import { HIDE_DELIVERY_ITEM_IMAGE_URL } from '../../../assets/deliveryDialogAssets';
import './HideDeliveryItemImage.css';

export function HideDeliveryItemImage() {
  return (
    <img
      className="new-delivery-hide-item"
      src={HIDE_DELIVERY_ITEM_IMAGE_URL}
      alt=""
      draggable={false}
    />
  );
}
